import * as React from 'react'

import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'
import AccessGroup from 'modules/core/store/models/AccessGroup'

interface Props {
  readonly?: boolean
  field: Field
}

const CompanyGroupSelection = ({ readonly, field }: Props) => {
  const companyOptions = [
    {
      value: AccessGroup.Strategies.withRegularAccess,
      label: i18n.t('surveys.new.form.labels.company.including_externals'),
    },
    {
      value: AccessGroup.Strategies.employees,
      label: i18n.t('surveys.new.form.labels.company.excluding_externals'),
    },
  ]

  return (
    <Select
      none={i18n.t('common.none')}
      readonly={readonly}
      field={field}
      options={companyOptions}
    />
  )
}

export default observer(CompanyGroupSelection)
